export default __webpack_public_path__ + "static/media/Avatar-9.7973a5a1.png";